import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class ERROR_GRAPH__base extends DTO__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.ABSTRACT;

  /*
   * STATIC METHODS
   */
  static create(type: ENUM__error_type) {
    let out = new ERROR_GRAPH__base();

    out.type = type;

    return out;
  }

  static get_unique(errors: ERROR_GRAPH__base[]) {
    return errors.filter((error, index) => errors.findIndex(e => e.is_equals(error)) === index);
  }

  /*
   * FIELDS
   */

  type!: ENUM__error_type;

  /*
   * METHODS
   */

  is_equals(other: ERROR_GRAPH__base): boolean {
    return this.type == other.type;
  }

  assert_standard_fields(): void {
    assert_type_enum(this.type, ENUM__error_type);
  }
}
